import {Locale} from '../RootProvider/LocaleContext';

export const isValidLocale = (locale: string): boolean => {
  return Object.values<string>(Locale).includes(locale);
};
